import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { DocumentClient, DocumentServiceClient, DocumentServices, Documents, ServiceProvider, ServiceProvidersClient } from "src/app/web-api-client";

@Component({
  selector: 'app-documentService-edit',
  templateUrl: './documentService-edit.component.html',
  styleUrls: ['./documentService-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentServiceEditComponent implements OnInit {

  public documentService: DocumentServices;
  public isLoaded = false;
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  public documents: Documents[] = [];
  public selectedDocument: Documents;
  constructor(private fb: FormBuilder, public cdr: ChangeDetectorRef, public activeModal: NgbActiveModal, public documentClient: DocumentClient, public client: DocumentServiceClient) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.isLoaded = false;

    this.documentClient.getList().subscribe(r => {

      this.documents = r;
      this.selectedDocument = this.documents.find(s=>s.idDocument == this.documentService.documents.idDocument);

      this.Form = this.fb.group({
        isActive: [this.documentService.isActive, Validators.required],
        order: [this.documentService.order, Validators.required],
        isRequired: [this.documentService.isRequired, Validators.required],
        isDownloadable: [this.documentService.isDownloadable, Validators.required],
      });

      this.isLoaded = true;
      this.cdr.detectChanges();
    });




  }

  onDocumentChange(selectedValue: string) {

    this.selectedDocument = this.documents.find(d => d.idDocument == +selectedValue);
    this.cdr.detectChanges();
  }


  onSubmit() {
    if (this.Form.valid) {

      let service = new DocumentServices();


      this.documentService.documentsIdDocument = this.selectedDocument.idDocument;
      this.documentService.isRequired = this.Form.value.isRequired;
      this.documentService.isDownloadable = this.Form.value.isDownloadable;
      this.documentService.order = +this.Form.value.order;
      this.documentService.isActive = this.Form.value.isActive;

      this.client.update(this.documentService).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public trimTitle(title: string): string {
    return title.length > 15 ? title.substring(0, 15) : title;
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  public isSelected(item: Documents): boolean {

    return this.selectedDocument.idDocument == item.idDocument;
  }

}
